module.exports = __webpack_public_path__ + "img/9788993722208.9b09de77.jpg";